// extracted by mini-css-extract-plugin
export default {"panel":"panel___panel___aa0dfe39","panelBody":"panel___panelBody___ff9d2e76"};